module.exports = __webpack_public_path__ + "img/cx_avaliacao_glicemia_pressao.c607494b.webp";